import API from './API.js';
export default class VideoGallery extends API {
    constructor() {
         super(`video-gallery`)
    }

}
